/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_History_LabelInputs */

const es_privacy_policy_retention_history_label = /** @type {(inputs: Privacy_Policy_Retention_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de Conversaciones`)
};

const en_privacy_policy_retention_history_label = /** @type {(inputs: Privacy_Policy_Retention_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation History`)
};

/**
* | output |
* | --- |
* | "Conversation History" |
*
* @param {Privacy_Policy_Retention_History_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_history_label = /** @type {((inputs?: Privacy_Policy_Retention_History_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_History_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_history_label(inputs)
	return en_privacy_policy_retention_history_label(inputs)
});
export { privacy_policy_retention_history_label as "privacy_policy.retention.history_label" }